'use client';

import { useEffect } from 'react';
import Pagination from '../../src/components/Pagination';
import CategoryGrid from '../../src/components/CategoryGrid';
import Breadcrumb from '../../src/components/Breadcrumb';
import track from '../../src/analytics/track';
import Subtext from '../../src/components/Subtext';
import getTemplate from '../../src/analytics/templates';

function Category({
  breadcrumbs,
  category,
  headline,
  altHeadline,
  locale,
  page,
  pagination,
  showAllCategories,
  subcategories,
}) {
  // get template name for analytics
  const template = getTemplate('/[category]/');

  useEffect(() => {
    track.page({
      language: locale,
      template,
      event: 'async',
      eventInfo: {
        category: 'content',
        action: 'loaded',
        details: `Category: ${category}`,
        value: 1,
      },
    });
  }, [category, locale, template]);

  return (
    <main className="wrapper" tabIndex="-1" id="main">

      <Breadcrumb crumbs={breadcrumbs} />

      <CategoryGrid
        categories={subcategories}
        headline={headline}
        pagination={(
          <Pagination
            hasNextPage={pagination?.nextPage}
            hasPrevPage={pagination?.prevPage}
            selectedPage={page}
            showAllProducts={showAllCategories}
            totalPages={pagination?.totalPages}
          />
        )}
      />

      <Subtext altHeadline={altHeadline} />

    </main>
  );
}

export default Category;
